
export default (token, page, params) => {
    switch (page) {
        case "volunteer":
        case "student":
        case "company_coordinator":
        case "center_coordinator":
            if (page === "student" && token.role === "center_coordinator") return true
            if (page === "volunteer" && token.role === "company_coordinator") return true
            if (token.from_role_id != params.id) return false
        break;
    }
    return true
}